import { render, staticRenderFns } from "./KeyIngressIframe.vue?vue&type=template&id=4ff8f38c&scoped=true"
import script from "./KeyIngressIframe.vue?vue&type=script&lang=js"
export * from "./KeyIngressIframe.vue?vue&type=script&lang=js"
import style0 from "./KeyIngressIframe.vue?vue&type=style&index=0&id=4ff8f38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff8f38c",
  null
  
)

export default component.exports